import { defineFormConfig } from "@src/components/business-form";

/** Значения формы поиска элемента состава АИ. */
export interface WsInvActCardSearchFormValues {
    stockObjSign: string;
}

export const wsInvActCardSearchFormConfig = defineFormConfig<WsInvActCardSearchFormValues, WsInvActCardSearchFormValues>({
    fields: {
        stockObjSign: {
            type: "string",
            label: "Обозначение ТМЦ",
            validation: { required: true },
            map: "stockObjSign",
        },
    },
});
